// removed by extract-text-webpack-plugin
module.exports = {"card":"card__13TAZ","search-input":"search-input__dcQcS","pl15":"pl15__3X77Q","ml15":"ml15__25pfb"};


//////////////////
// WEBPACK FOOTER
// ./styles/elss-calculator.scss
// module id = 740
// module chunks = 68